import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { adminRoot } from 'constants/defaultValues';
import {
  requestCollectionsList,
  requestCreateCollection,
  requestDeleteCollection,
  requestUpdateCollection,
} from 'helpers/api';
import {
  createCollectionError,
  createCollectionSuccess,
  deleteCollectionError,
  deleteCollectionSuccess,
  getCollectionsError,
  getCollectionsSuccess,
  updateCollectionError,
  updateCollectionSuccess,
} from './actions';
import {
  CREATE_COLLECTION,
  DELETE_COLLECTION,
  GET_COLLECTIONS,
  UPDATE_COLLECTION,
} from '../contants';

function* getCollections() {
  try {
    const gotCollection = yield call(requestCollectionsList);
    if (gotCollection.result) {
      // gotCollection.data should be an array of collections
      yield put(getCollectionsSuccess(gotCollection.data));
    } else {
      yield put(getCollectionsError(gotCollection.message));
    }
  } catch (error) {
    yield put(getCollectionsError(error.message));
  }
}

export function* watchGetCollection() {
  yield takeEvery(GET_COLLECTIONS, getCollections);
}

function* createCollection({ payload }) {
  const { collection } = payload;
  const { history } = payload;
  try {
    const result = yield call(requestCreateCollection, collection);

    if (result.result) {
      const item = result.data;
      yield put(createCollectionSuccess(item));
      history.push(`${adminRoot}/collections-page?collection=${item.id}`);
    } else {
      yield put(createCollectionError(result.message));
    }
  } catch (error) {
    yield put(createCollectionError(error.message));
  }
}

export function* watchCreateCollection() {
  yield takeEvery(CREATE_COLLECTION, createCollection);
}

function* updateCollection({ payload }) {
  const result = yield call(requestUpdateCollection, payload);
  if (result.result) yield put(updateCollectionSuccess(result.data));
  else yield put(updateCollectionError(result.message));
}
export function* watchUpdateCollection() {
  yield takeEvery(UPDATE_COLLECTION, updateCollection);
}

function* deleteCollection({ payload }) {
  const { collection, history } = payload;
  const result = yield call(requestDeleteCollection, collection.id);
  if (result.result) {
    yield put(deleteCollectionSuccess(result.data.id));
    history.push(`${adminRoot}/collections-page`);
  } else yield put(deleteCollectionError(result.message));
}

export function* watchDeleteCollection() {
  yield takeEvery(DELETE_COLLECTION, deleteCollection);
}

// Export root saga and add all watches here
export default function* rootSaga() {
  yield all([
    fork(watchGetCollection),
    fork(watchCreateCollection),
    fork(watchUpdateCollection),
    fork(watchDeleteCollection),
  ]);
}
